import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import * as variables from 'styles/variables';
import OnClickOutside from 'components/Styled/Modal/OnClickOutside';
import PropTypes from 'prop-types';
import { Row } from 'components/Styled/Basic';
import { useAnimationDelay } from 'components/Styled/Modal/utils/useDelay';

const Content = styled.div`
    position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	min-width: 24px;
	height: 100%;
	transition: all .2s ease;
	cursor: pointer;

	color: ${(props) => props.$isActive ? variables.tabColors.tabActive : variables.tabColors.textColorDark };
`;

const OptionsList = styled(OnClickOutside)`
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: absolute;
	top: calc(100% + 7px);
	right: calc(50% - 12px);
	transition: all .2s ease;
	min-width: 200px;
	z-index: 9999;
	background: #fff;
	padding: 10px 0;
	opacity: ${(props) => props.isActive ? '1' : '0' };
	box-shadow: ${(props) => props.isActive ? '0 0 10px 4px rgba(0, 0, 0, 0.2)' : 'none' };
	border-radius: 6px;
	
	&:after {
		bottom: 100%;
		right: 7px;
		border: 5px solid transparent;
		border-bottom-color: #fff;
		content: " ";
		height: 0;
		width: 0;
		position: absolute;
		pointer-events: none;
		margin-left: -5px;
	}
`;

const OptionsContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	max-height: 400px;
	overflow-y: auto;
	width: 100%;
`;

export const OptionItem = styled(Link)`
	box-sizing: border-box;
	display: flex;
	justify-content: flex-start;
	width: 100%;
    padding: 10px 15px;
	font: 11px/1.1 "SFUIText-Bold", Arial, sans-serif;
	text-transform: uppercase;
	color: ${(props) => props.color || variables.tabColors.textColorLight};
	
	&:visited, &:link {
		color: ${(props) => props.color || variables.tabColors.textColorLight};
	}
	
	&:hover {
		color: ${variables.tabColors.tabActive};
		background: ${variables.gridColors.gridNthLine};
	}
`;

const HeaderOptions = ({ options, closeOnSelect = true, children, renderItem: OptionItem }) => {
	const {
		isActive,
		isOpened,
		handleClose,
		handleOpen,
		toggle,
	} = useAnimationDelay();

	return (
		<Content $isActive={isOpened} onClick={closeOnSelect ? toggle : handleOpen}>
			{children}

			{isActive && (
				<OptionsList isActive={isOpened} onClickOutside={handleClose}>
					<OptionsContent>
						{!options.length && (
							<Row>Немає даних</Row>
						)}

						{options.map(({ label: Label, disabled, renderItem: CustomItem, ...option }, i) => {
							if (disabled) {
								return null;
							}

							const Item = CustomItem || OptionItem;

							return (
								<Item
									key={`OptionItem-${i}`}
									{...option}
									component={option.to ? 'a' : 'span'}
								>
									{typeof Label === 'function' ? <Label {...option} /> : Label}
								</Item>
							);
						})}
					</OptionsContent>
				</OptionsList>
			)}
		</Content>
	);
};

HeaderOptions.defaultProps = {
	options: [],
	children: (
		<i className="icon-kebab-vert" />
	),
	renderItem: OptionItem,
};

HeaderOptions.propTypes = {
	options: PropTypes.array.isRequired,
	closeOnSelect: PropTypes.bool,
	children: PropTypes.any,
};

export default HeaderOptions;
